import {
  Box,
  FormControl,
  FormLabel,
  Input,
  NumberInput,
  NumberInputField
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import Confirmation from '../../../../components/confirmation/Confirmation';
import { addNewProduction } from '../../../../slice/certificateIssuerHomeSlice';

function CreateEventConfirmation(props) {
  const dispatch = useDispatch();
  const { isOpen, handleClose } = props;
  const [productionName, setProductionName] = useState('');
  const [year, setYear] = useState(String(new Date().getFullYear()));

  const createNewEvent = async() => {
    // Sector is now fetched from account on backend - no longer required from user
    const res = (await dispatch(addNewProduction({ productionName, year, fieldConfigs: null }))).payload;

    if (res?.ok) {
      setProductionName('');
      handleClose(true);
    }
  };

  const header = 'Create new production';

  const Body = (
    <Box w='100%' h='100%' overflow='auto' className='custom-scrollbar'>
      <FormControl>
        <FormLabel>Production Name</FormLabel>
        <Input placeholder='Production Name' value={productionName} onChange={e => setProductionName(e.target.value)}/>
        <FormLabel>Production Year</FormLabel>
        <NumberInput placeholder='Production Year' defaultValue={year} onChange={setYear}>
          <NumberInputField />
        </NumberInput>
      </FormControl>
    </Box>
  );

  return (
    <Confirmation
      body={Body}
      header={header}
      isOpen={isOpen}
      handleClose={handleClose}
      handleAction={createNewEvent}
      actionButtonBgColor='#007bff'
      actionButtonHover={{ bg: '#0069d9', color: 'whitesmoke' }}
    />
  );
}

CreateEventConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func
};

export default CreateEventConfirmation;
